import React from 'react';
import { colors } from '@noths/polaris-client-ribbons-base';
import { IconInfo } from '@noths/polaris-client-ribbons-design-system';

import * as styles from 'src/styles/styles';
import { SECTION_WARNING_LINE } from './copy';

export const WarningMessage = () => (
  <div css={styles.warningField}>
    <IconInfo color={colors.brandBlueDark} css={styles.warningIcon} />
    <p>{SECTION_WARNING_LINE}</p>
  </div>
);
